<style>
.tips-mask .tips-auto-wrapper{
	position: absolute;
	color: #fff;
	top: 50%;
	width: 70%;
	margin: 0 15%;
	margin-top: -30px;
	border-radius: 4px;
	font-size: 14px;
	background-color: rgba(0,0,0,.8);
	box-shadow: 0px 5px 10px rgba(0,0,0,.1);
}
.tips-mask .tips-auto-wrapper .tips-auto-font{
	margin: 0;
	text-align: center;
	min-height: 60px;
	height: auto;
	box-sizing: border-box;
	padding: 2px;
	vertical-align: middle;
}
.tips-mask .tips-wrapper .tips-auto-font p{
	margin: .5em 0;
}
</style>

<template>
	<div class="tips-mask">
		<div class="tips-auto-wrapper">
			<div class="tips-auto-font"><p>{{tipsFont}}</p></div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		tipsFont: String
	}
}
</script>



// WEBPACK FOOTER //
// TipsAuto.vue?6b7f331a